import { render, staticRenderFns } from "./addrealNamePames.vue?vue&type=template&id=7f9b458b&"
import script from "./addrealNamePames.vue?vue&type=script&lang=js&"
export * from "./addrealNamePames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f9b458b')) {
      api.createRecord('7f9b458b', component.options)
    } else {
      api.reload('7f9b458b', component.options)
    }
    module.hot.accept("./addrealNamePames.vue?vue&type=template&id=7f9b458b&", function () {
      api.rerender('7f9b458b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/components/addrealNamePames.vue"
export default component.exports